module.exports = __webpack_public_path__ + "img/dark-compare.726d5b6c.png";